
import {
  computed, defineComponent, reactive,
} from 'vue';
import Card from '@/core/components/UI/Card.vue';
import Icone from '@/core/components/UI/Icone.vue';
import ManualPreenchimentoInspecao from '@/models/Constantes/ManualPreenchimentoInspecao';
import { IInspecaoSecao3 } from '@/models/Entidades/IInspecao';

export default defineComponent({
  name: 'InspecaoSecao3',
  props: {
    secao3: {
      type: Object as () =>IInspecaoSecao3,
      required: true,
    },
    bloquearCampos: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    Card,
    Icone,
  },
  emits: ['update:secao3', 'change'],
  setup(props, { emit }) {
    const state = reactive({
      enviandoArquivos: false,
      excluindoArquivos: false,
      manuaisPreenchimento: {} as Record<string, boolean>,
    });

    const computedSecao3 = computed({
      get: () => props.secao3,
      set: (valor: IInspecaoSecao3) => {
        emit('update:secao3', valor);
      },
    });

    function change() {
      emit('change');
    }

    function alternarManualPreenchimento(chave: string) {
      state.manuaisPreenchimento[chave] = !state.manuaisPreenchimento[chave];
    }

    return {
      props,
      computedSecao3,
      state,
      change,
      ManualPreenchimentoInspecao,
      alternarManualPreenchimento,
    };
  },
});
